import { stateKey } from '../app/state-key.js';
import * as PLSelectors from '../features/commerce/product-listing/product-listing-selectors.js';
import * as SearchSelectors from '../features/commerce/search/search-selectors.js';
export var Search;
(function (Search) {
    Search.responseIdSelector = wrapWithAccessFromEngine(SearchSelectors.responseIdSelector);
})(Search || (Search = {}));
export var ProductListing;
(function (ProductListing) {
    ProductListing.responseIdSelector = wrapWithAccessFromEngine(PLSelectors.responseIdSelector);
})(ProductListing || (ProductListing = {}));
function wrapWithAccessFromEngine(selector) {
    return (engine) => selector(engine[stateKey]);
}
